"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Switch = _interopRequireDefault(require("../Switch/Switch"));
var _excluded = ["classes", "control", "dataMetrics", "label", "labelPlacement", "row", "subLabel"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = function useStyles(_ref) {
  var row = _ref.row;
  return (0, _styles.makeStyles)(function (theme) {
    return {
      formControlLabelRoot: {
        '&:not(:last-child)': {
          marginBottom: row ? null : theme.spacing(1)
        },
        alignItems: 'start',
        marginLeft: 0,
        marginRight: theme.spacing(2),
        width: 'fit-content'
      },
      label: _objectSpread({}, theme.typography.body1, {
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(0, 1),
        padding: '6px 0px'
      }),
      subLabel: {
        marginTop: theme.spacing(0.5)
      },
      switchMargin: {
        marginTop: '-4px'
      }
    };
  })();
};
var defaultProps = {
  dataMetrics: {
    root: 'fuse_form_control_label'
  },
  labelPlacement: 'end'
};

/**
 * Drop in replacement of the Radio, Switch and Checkbox component. Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _control$type;
  var classes = _ref2.classes,
    control = _ref2.control,
    dataMetrics = _ref2.dataMetrics,
    labelProp = _ref2.label,
    labelPlacement = _ref2.labelPlacement,
    row = _ref2.row,
    subLabel = _ref2.subLabel,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var componentClasses = useStyles({
    row: row
  });
  var mergedClasses = _objectSpread({}, componentClasses, {}, classes);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var label = labelProp;
  if (labelProp && subLabel) {
    label = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, null, labelProp), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      className: mergedClasses.subLabel,
      variant: "caption",
      color: "textSecondary"
    }, subLabel));
  }
  var localControl = control;
  if ((control === null || control === void 0 ? void 0 : (_control$type = control.type) === null || _control$type === void 0 ? void 0 : _control$type.displayName) === _Switch["default"].displayName) {
    localControl = /*#__PURE__*/_react["default"].createElement("div", {
      className: mergedClasses.switchMargin
    }, control);
  }
  return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], (0, _extends2["default"])({
    classes: _objectSpread({
      label: (0, _classnames["default"])(mergedClasses.label, classes === null || classes === void 0 ? void 0 : classes.label),
      root: (0, _classnames["default"])(mergedClasses.formControlLabelRoot, classes === null || classes === void 0 ? void 0 : classes.root)
    }, classes),
    "data-metrics": mergedDataMetrics.root,
    label: label,
    labelPlacement: labelPlacement,
    control: localControl,
    ref: ref
  }, props));
});
FormControlLabel.displayName = 'FormControlLabel';
FormControlLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true` the component appears selected.
   */
  checked: _propTypes["default"].bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/form-control-label/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes["default"].element,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true` the control will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes["default"].node,
  /**
   * The position of the label.
   */
  labelPlacement: _propTypes["default"].oneOf(['end', 'start']),
  /*
   * @ignore
   */
  name: _propTypes["default"].string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing event.target.checked.
   * @param {boolean} checked The checked value of the switch
   */
  onChange: _propTypes["default"].func,
  /*
   * @ignore
   * Display group of elements in a compact row.
   */
  row: _propTypes["default"].bool,
  /**
   * The text to be used in an enclosing sub label element.
   */
  subLabel: _propTypes["default"].node,
  /**
   * The value of the component.
   */
  value: _propTypes["default"].string
} : {};
FormControlLabel.defaultProps = defaultProps;
var _default = FormControlLabel;
exports["default"] = _default;